import { createSlice } from "@reduxjs/toolkit";
import Parse from "../../Utilities/parse";

export const StockedItemSlice = createSlice({
    name: "stockedItemSlice",
    initialState: {
        allStockedItem: [],
        allStockedItemWithPagination: {
            total_page_count: 1,
            data: []
        }
    },
    reducers: {
        getStockReducer: (state, action) => {
            state.allStockedItem = action.payload
        },
        // get all stocked item with pagination reducer
        getAllStockedItemWithPaginationReducer: (state, action) => {
            state.allStockedItemWithPagination = {
                total_page_count: Parse.toNumber(action?.payload?.total_page_count),
                data: action?.payload?.data || []
            }
        }
    }
})